import React from 'react';

const SettingsToggle = ({
  label,
  description,
  checked,
  onChange,
  color = 'blue',
  disabled = false,
}) => {
  const colorClasses = {
    blue: 'bg-carmin',
    purple: 'bg-accent-purple',
    green: 'bg-green-600',
  };

  return (
    <div className="flex items-center justify-between">
      <div>
        <label className="block text-sm font-medium text-label">{label}</label>
        {description && (
          <p className="text-sm text-muted">{description}</p>
        )}
      </div>
      <button
        type="button"
        onClick={() => !disabled && onChange(!checked)}
        disabled={disabled}
        className={`
          relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full
          border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none
          ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
          ${checked ? colorClasses[color] : 'bg-dark-hover'}
        `}
      >
        <span
          className={`
            pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white
            shadow ring-0 transition duration-200 ease-in-out
            ${checked ? 'translate-x-5' : 'translate-x-0'}
          `}
        />
      </button>
    </div>
  );
};

export default SettingsToggle;
